import { useEffect } from "react";

import { useTypedQuery } from "hooks";
import { useRecallsDashboardFilters } from "modules/RecallsDashboard/hooks";
import { RecallsDashboardKeys } from "modules/RecallsDashboard/queryKeys";
import ApiInstance from "util/Api";

export const useSearchRecalls = () => {
  const { data: filters } = useRecallsDashboardFilters();

  const { data, refetch, isFetching } = useTypedQuery({
    queryKey: RecallsDashboardKeys.search,
    queryFn: async () => (await ApiInstance.post(RecallsDashboardKeys.search.endpoint, filters, RecallsDashboardKeys.search.baseUrl)).data
  });

  useEffect(() => {
    refetch();
  }, [filters]);

  return { data, isFetching };
};

export const useRecallsLastImport = () => {
  return useTypedQuery({
    queryKey: RecallsDashboardKeys.lastImport,
    queryFn: async () => (await ApiInstance.get(RecallsDashboardKeys.lastImport.endpoint, RecallsDashboardKeys.lastImport.baseUrl)).data
  });
};
